<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="pages-menu-wrapper">
                <div class="burger-menu">
                    <button type="button" class="burger-btn" aria-label="Open page list">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>

                    <ul class="pages-menu-list" *ngIf="pages?.length">
                        <li *ngFor="let page of pages">
                            <button
                                type="button"
                                class="page-option"
                                [class.active]="selectedPage?.name === page?.name"
                                (click)="onPageChange(page)">
                                {{ page?.name }}
                            </button>
                        </li>
                    </ul>
                </div>

                <div class="selected-page-label">
                    <span>{{ selectedPage?.name || 'N/A' }}</span>
                </div>
            </div>
        </div>
    </div>
</div>